import { PAGE_TYPE } from "@supplier/meta";
import { RouteRecordRaw } from "vue-router";

const salesManageRouter: RouteRecordRaw[] = [
    {
        path: "/salesManage",
        name: "SalesManage",
        meta: {
            title: "销售管理"
        },
        component: () => import("@/views/layouts/index.vue"),
        children: [
            // 订单
            {
                path: "order",
                name: "SalesOrderManagement",
                meta: {
                    title: "订单管理",
                    pageType: PAGE_TYPE.LIST.code
                },
                component: () => import("@/views/pages/salesManagement/orderManagement/index.vue")
            },
            {
                path: "order/detail/:id",
                name: "SalesOrderInfo",
                meta: { title: "订单详情", hidden: true, activeMenu: "SalesOrderManagement", keepAlive: true },
                component: () => import("@/views/pages/salesManagement/orderManagement/detail.vue")
            },
            // 发货
            {
                path: "delivery",
                name: "SalesDelivery",
                component: () => import("@/views/pages/salesManagement/deliveryManagement/index.vue"),
                meta: {
                    title: "发货管理",
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "deliveryDetail",
                name: "SalesDeliveryDetail",
                component: () => import("@/views/pages/salesManagement/deliveryManagement/detail.vue"),
                meta: {
                    title: "发货详情",
                    activeMenu: "SalesDelivery",
                    hidden: true,
                    isNotShowHeader: true
                }
            },
            {
                path: "deliveryAdd",
                name: "SalesDeliveryAdd",
                component: () => import("@/views/pages/salesManagement/deliveryManagement/form.vue"),
                meta: {
                    title: "新增发货",
                    activeMenu: "SalesDelivery",
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true
                }
            },
            {
                path: "deliveryEdit",
                name: "SalesDeliveryEdit",
                component: () => import("@/views/pages/salesManagement/deliveryManagement/form.vue"),
                meta: {
                    title: "修改发货",
                    activeMenu: "SalesDelivery",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            },
            // 签收
            {
                path: "receipt",
                name: "SaleReceipt",
                component: () => import("@/views/pages/salesManagement/receiptManagement/index.vue"),
                meta: {
                    title: "签收管理",
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "receipt/detail/:id",
                name: "SaleReceiptInfo",
                component: () => import("@/views/pages/salesManagement/receiptManagement/detail.vue"),
                meta: {
                    title: "签收详情",
                    activeMenu: "SaleReceipt",
                    hidden: true,
                    isNotShowHeader: true
                }
            },
            // 结算
            {
                path: "reconciliation",
                name: "SaleReconciliation",
                component: () => import("@/views/pages/salesManagement/reconciliation/index.vue"),
                meta: {
                    title: "结算管理",
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "reconciliation/add",
                name: "SaleReconciliationAdd",
                component: () => import("@/views/pages/salesManagement/reconciliation/form.vue"),
                meta: {
                    title: "新增结算",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "SaleReconciliation"
                }
            },
            {
                path: "reconciliation/edit/:id",
                name: "SaleReconciliationEdit",
                component: () => import("@/views/pages/salesManagement/reconciliation/form.vue"),
                meta: {
                    title: "修改结算",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "SaleReconciliation",
                    isNotShowHeader: true
                }
            },
            {
                path: "reconciliation/:id",
                name: "SaleReconciliationInfo",
                component: () => import("@/views/pages/salesManagement/reconciliation/details.vue"),
                meta: {
                    title: "结算详情",
                    hidden: true,
                    customize: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "SaleReconciliation",
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default salesManageRouter;
